<template>
  <v-container grid-list-sm>
    <ProjectResponseHeader />
    <br />
    <ProjectResponseMenuTab :active="2" />
    <br />
    <v-layout>
      <v-flex sm12>
        <ProjectPreviewContent />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ProjectResponseHeader from "../../components/project/ProjectResponseHeader";
import ProjectResponseMenuTab from "../../components/project/ProjectResponseMenuTab";
import ProjectPreviewContent from "../../components/project/ProjectPreviewContent";

export default {
  data() {
    return {
      apiUrl: "project-info-details",
    };
  },
  components: {
    ProjectResponseHeader,
    ProjectResponseMenuTab,
    ProjectPreviewContent,
  },
  created() {
    this.getProjectDetails();
  },
  methods: {
    async getProjectDetails() {
      this.$store.dispatch("indexData", [this.apiUrl, this.$route.params.id]);
    },
  },
};
</script>
